export default __webpack_public_path__ + "static/2-3a2a080e1bf441aafe50e528bd0cd36f.jpeg";